import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[translate]'
})
export class TranslateDirective implements OnInit, OnDestroy {
  @Input() translate: string;
  private sub: Subscription;

  constructor(
    private el: ElementRef,
    private translationService: TranslationService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    // Initial translation
    this.updateTranslation();
    
    // Subscribe to language changes
    this.sub = this.translationService.langChange.subscribe(() => {
      this.updateTranslation();
    });
  }

  private updateTranslation() {
    if (this.translate) {
      console.log('[TranslateDirective] Translating key:', this.translate);
      const translated = this.translationService.translate(this.translate);
      console.log('[TranslateDirective] Translated value:', translated);
      
      // Use Renderer2 to safely update the DOM
      this.renderer.setProperty(this.el.nativeElement, 'textContent', translated);
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
